module.exports = __webpack_public_path__ + "static/email-template-canceled-subscription-083fa1af1f932e94530e6187f0547d72.png";